<template>
  <v-card class="repse-container">
    <v-card-title>
      Documentación Repse
    </v-card-title>

    <v-card-text>
      <div class="repse-section">
        <v-subheader>Documentos por cargar</v-subheader>
        <v-row>
          <v-col cols="4" v-for="doc in notValidatedDocs" :key="'nv-' + doc.id">
            <v-file-input
              :label="doc.nombre"
              accept="application/pdf"
              v-model="docs[doc.id]"
              :rules="repseRules(doc)"
            />
          </v-col>
        </v-row>
      </div>

      <div class="repse-section">
        <v-subheader>Documentos pendientes de validación</v-subheader>
        <v-row>
          <v-col cols="4" v-for="doc in pendingDocs" :key="'p-' + doc.id">
            <v-card outlined>
              <v-card-title class="text-subtitle-2">
                {{ doc.nombre }}
              </v-card-title>
              <v-card-text>
                <v-chip color="orange" text-color="white" small>
                  {{ doc.estado }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div class="repse-section">
        <v-subheader>Documentos validados</v-subheader>
        <v-row>
          <v-col cols="4" v-for="doc in validatedDocs" :key="'v-' + doc.id">
            <v-card outlined>
              <v-card-title class="text-subtitle-2">
                <a :href="`${$store.state.proveedorUrl}${doc.ruta_documento}`" target="_blank">
                  {{ doc.nombre }}
                </a>
              </v-card-title>
              <v-card-text>
                <v-chip color="green" text-color="white" small>
                  {{ doc.estado }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.repse-container {
  border-radius: 5px;
  padding: 10px;
}

.repse-section {
  border: 1px solid #f2f2f20a;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}
</style>

<script>
import {
    INVOICE_UPLOAD_LIMITS,
    PDF_MIME_TYPES,
    fileSizeRule,
    fileTypeRule,
    requiredRule
} from '../../utils/uploadValidation';

export default {
    name: "RepseForm",
    props: {
        serviceUrl: { type: String, required: true },
        locale: { type: String, default: "es" },
        docs: { type: Object, default: () => ({}) },
        docsRepse: { type: Array, default: () => [] }
    },
    data() {
        return {
            availableDocs: []
        };
    },
    computed: {
        notValidatedDocs() {
            const result = this.availableDocs.filter(avDoc => {
                const match = this.docsRepse.find(repse => repse.nombre === avDoc.nombre);
                return !match || match.estado === "No Validado";
            });
            return result;
        },
        pendingDocs() {
            const result = this.docsRepse.filter(d => d.estado === "Pendiente");
            return result;
        },
        validatedDocs() {
            const result = this.docsRepse.filter(d => d.estado === "Validado");
            return result;
        }
    },
    watch: {
        docs: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true
        }
    },
    async mounted() {
        await this.getDocuments();
    },
    methods: {
        repseRules(doc) {
            return [
                requiredRule(doc.nombre),
                fileSizeRule(INVOICE_UPLOAD_LIMITS.repse),
                fileTypeRule(PDF_MIME_TYPES, 'PDF')
            ];
        },
        async getDocuments() {
            try {
                const { data } = await this.sendRequest(
                    `${this.serviceUrl}catalogos/documentos-repse`,
                    { idioma: this.locale }
                );
                this.availableDocs = data;
            } catch (err) {
                console.error("Error cargando documentos:", err);
            }
        }
    }
};
</script>
